import { CREDIT_NOTE_BILL_BASE_REQUEST, CREATE_CREDIT_NOTE_BILL_BASE, GET_CREDIT_NOTE_BILL_BASES, UPDATE_CREDIT_NOTE_BILL_BASE,
  DELETE_CREDIT_NOTE_BILL_BASE, CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS, 
  GET_CREDIT_NOTE_BILL_BASES_PAGE } from '../types';

const initialState = {
  creditNoteBillBases: [],
  creditNoteBillBasesPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const creditNoteBillBaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREDIT_NOTE_BILL_BASE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_CREDIT_NOTE_BILL_BASES: {
      return {
        ...state,
        creditNoteBillBases: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_CREDIT_NOTE_BILL_BASES_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        creditNoteBillBasesPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_CREDIT_NOTE_BILL_BASE: {
      return {
        ...state,
        creditNoteBillBases: [action.payload, ...state.creditNoteBillBases],
        loading: false,
        error: null
      };
    }
    case UPDATE_CREDIT_NOTE_BILL_BASE: {
      const creditNoteBillBasesData = state.creditNoteBillBases.slice(0);
      const uIndex = creditNoteBillBasesData.findIndex((data) => data.id === action.payload.id);
      creditNoteBillBasesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        creditNoteBillBases: [ ...creditNoteBillBasesData ],
        loading: false,
        error: null
      };
    }
    case DELETE_CREDIT_NOTE_BILL_BASE: {
      const creditNoteBillBases = state.creditNoteBillBases?.slice(0);
      const index = creditNoteBillBases.findIndex((data) => data.id === action.id);
      if (index > -1) {
        creditNoteBillBases.splice(index, 1);
      }
      return {
        ...state,
        creditNoteBillBases: [...creditNoteBillBases],
        loading: false,
        error: null
      }
    }
    case CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default creditNoteBillBaseReducer;